import { render, staticRenderFns } from "./DateTime.vue?vue&type=template&id=566c2964&"
import script from "./DateTime.vue?vue&type=script&lang=js&"
export * from "./DateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports